import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { uniqBy } from 'lodash';

import { getBrandRegistrationCodes } from '../../api/registration_codes';

let searchDebouncer;
const BrandOnboardingData = props => {
  const { brandRegistrationCodes, setBrandRegistrationCodes, limit, offset } = props;
  const { curSearchValue, setIsSearching } = props;

  useEffect(() => {
    if (!searchDebouncer && curSearchValue?.length > 0 && curSearchValue?.length < 3) return;

    setIsSearching(true);
    searchDebouncer && clearTimeout(searchDebouncer);
    searchDebouncer = setTimeout(() => {
      getBrandRegistrationCodes({ limit, offset, query: curSearchValue })
        .then(res => {
          if (curSearchValue?.length) {
            setBrandRegistrationCodes(res.brandRegistrationCodes);
          } else {
            const existingBrandRegistrationCodes = offset === 0 ? [] : brandRegistrationCodes;
            const updatedBrandRegistrationCodes = uniqBy(existingBrandRegistrationCodes.concat(res.brandRegistrationCodes), 'id');
            setBrandRegistrationCodes(updatedBrandRegistrationCodes);
          }
        })
        .catch(() => window.ALERT?.error('Error fetching registration codes'))
        .finally(() => setIsSearching(false));
    }, 1_000);
  }, [offset, limit, curSearchValue]);

  return null;
};

BrandOnboardingData.propTypes = {
  brandRegistrationCodes: PropTypes.array,
  setBrandRegistrationCodes: PropTypes.func.isRequired,
  limit: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,

  // searching state
  curSearchValue: PropTypes.string.isRequired,
  setIsSearching: PropTypes.func.isRequired,
  isSearching: PropTypes.bool.isRequired
};

export default BrandOnboardingData;
